module.exports = __webpack_public_path__ + "img/shop-discount.c17994f4.svg";